import React from "react";
import styles from "../PropertySelector.module.scss";
import classnames from "classnames";
import { Tooltip } from "~/components/tooltip/Tooltip";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import { isPropertyEnabled, translatePropertyValue } from "../propertyCore";
import CheckboxPropertySelectorWrapper from "./common/CheckboxPropertySelectorWrapper";
import { getBrandProductImageObjectFit } from "~/cores/brandDataCore";

export default function CheckboxImagePropertySelector(props) {
    const { appProps, exchangeAlternatives, selectedProperties, selectedPropertyValue, propertyValues, propertyType, onSelectedPropertyValue } = props;

    return (
        <CheckboxPropertySelectorWrapper {...props}>
            {propertyValues.map(({ value: propertyValue, imageSrc, name, nameShort }) => {
                let selected = selectedPropertyValue === propertyValue;
                let disabled = !isPropertyEnabled({
                    exchangeAlternatives,
                    propertyType,
                    propertyTypeChoices: selectedProperties,
                    propertyValue: propertyValue,
                });

                const propertyValueTranslated = translatePropertyValue({ ...props, propertyValue: propertyValue });

                // const isColorLight = chroma(hexColor).luminance() > 0.82;
                return (
                    <div
                        key={propertyValue}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Tooltip
                            tight={true}
                            content={
                                <div>
                                    <div>{name || nameShort || propertyValueTranslated}</div>

                                    {disabled && (
                                        <div className={"secondary-color"} style={{ marginTop: "5px" }}>
                                            {appProps?.getLocaleText("out-of-stock")}
                                        </div>
                                    )}
                                </div>
                            }
                        >
                            <div
                                className={classnames(styles["image-property-selector"], selected && styles["image-property-selected"], disabled && styles["image-property-disabled"])}
                                onClick={disabled ? undefined : () => onSelectedPropertyValue({ propertyValue: propertyValue })}
                            >
                                {/*{disabled && <div className={styles["image-property-disabled-icon"]} />}*/}

                                <CustomImageNew
                                    src={imageSrc}
                                    fill
                                    style={{
                                        objectFit: getBrandProductImageObjectFit(appProps),
                                        width: "100%",
                                        height: "100%",
                                    }}
                                    alt={propertyValue?.value}
                                />
                                <div
                                    className={styles["image-property-selector-white-cover"]}
                                    style={{
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "2px",
                                    }}
                                />
                                <div
                                    className={styles["image-property-selector-white-cover"]}
                                    style={{
                                        bottom: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "2px",
                                    }}
                                />
                                <div
                                    className={styles["image-property-selector-white-cover"]}
                                    style={{
                                        top: 0,
                                        right: 0,
                                        width: "2px",
                                        height: "100%",
                                    }}
                                />
                                <div
                                    className={styles["image-property-selector-white-cover"]}
                                    style={{
                                        top: 0,
                                        left: 0,
                                        width: "2px",
                                        height: "100%",
                                    }}
                                />
                            </div>
                        </Tooltip>
                        <div className={classnames(styles["name-short"], disabled && styles["property-disabled-slight-opacity"])}>{nameShort}</div>
                    </div>
                );
            })}
        </CheckboxPropertySelectorWrapper>
    );
}
